"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlankValue = undefined;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlankValue = exports.BlankValue = function BlankValue(props) {
  var children = props.children,
      className = props.className,
      icon = props.icon,
      iconClassName = props.iconClassName,
      noText = props.noText;


  return _react2.default.createElement(
    "span",
    { className: (0, _classnames2.default)("erg-components-BlankValue", className) },
    icon && _react2.default.createElement(_Icon2.default, {
      className: (0, _classnames2.default)("erg-margin-right-10", iconClassName),
      icon: icon }),
    !noText && (children || "--")
  );
};

BlankValue.defaultProps = {
  noText: false
};

BlankValue.displayName = "BlankValue";

BlankValue.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  noText: _propTypes2.default.bool
};

exports.default = BlankValue;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/BlankValue.js
 ** module id = 389
 ** module chunks = 0
 **/